import { MagnifyingGlassIcon } from '@radix-ui/react-icons';
import { Link, useParams } from '@tanstack/react-router';
import { EmptyState } from '@/components/states';
import { Button } from '@/components/ui/button';

export function OperatorNotFound() {
  const { operatorId } = useParams({ strict: false });
  return (
    <EmptyState
      icon={<MagnifyingGlassIcon />}
      title="Operator not found"
      description={
        operatorId
          ? `There's no operator #${operatorId}, or it's outside your operator scope. It may have been deleted.`
          : undefined
      }
      action={
        <Button variant="outline" asChild>
          <Link to="/operators">Back to operators</Link>
        </Button>
      }
    />
  );
}
